import { render, staticRenderFns } from "./ChatNotifications.vue?vue&type=template&id=c2561236&"
import script from "./ChatNotifications.vue?vue&type=script&lang=js&"
export * from "./ChatNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ChatNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports